import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=55660e63&scoped=true&"
var script = {}
import style0 from "./Template.vue?vue&type=style&index=0&id=55660e63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55660e63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/MATKP - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55660e63')) {
      api.createRecord('55660e63', component.options)
    } else {
      api.reload('55660e63', component.options)
    }
    module.hot.accept("./Template.vue?vue&type=template&id=55660e63&scoped=true&", function () {
      api.rerender('55660e63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/MATKP/views/Index/Template.vue"
export default component.exports